import { render, staticRenderFns } from "./sprite-transform.svg.vue?vue&type=template&id=e9a4ee42&"
import script from "./sprite-transform.svg.vue?vue&type=script&lang=js&"
export * from "./sprite-transform.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports